import { useParams } from "react-router";

import { ActivityByEnvV2 } from "../shared";

export const EnvironmentActivityPage = () => {
  const { id = "" } = useParams();
  return <ActivityByEnvV2 envId={id} />;
};
